module.exports = __webpack_public_path__ + "img/signUp.2e2327f6.svg";